import { ApisauceInstance } from 'apisauce';

// Url
import { url } from '../api.url';

// Type
type PropsFormDataPostProject = {
	[index: string]: string | number
};
type PropsFormDataUpdate = {
	userComment: string,
	shippingAddressId: number,
}

const orders = (api: ApisauceInstance) => {
	const getAllOrders = (urlParam: {
		[index: string]: string
	}) => api.get(`${url.getOrders}?withProductProperties=${urlParam.withProductProperties}`);
	const getOrderById = (id: number, withProductProperties: boolean) =>
		api.get(`${url.getOrders}/${id}?withProductProperties=${Object.values(withProductProperties)?.length ? withProductProperties : true}`);
	const postProject = (formData: PropsFormDataPostProject) => api.post(url.getOrders, formData || {});
	const updateOrder = (formData: PropsFormDataUpdate, id: number) => api.put(`${url.getOrders}/${id}`, formData || {});

	return {
		updateOrder,
		postProject,
		getAllOrders,
		getOrderById
	};
};

export default orders;
